import * as pd from '@/property-details/components/property-details-content-styles';
import { Placeholder } from 'rsuite';
import styled from 'styled-components';
import {
  SkeletonBlock,
  SkeletonTitle,
  SolidSkeletonSection,
} from './generic-skeleton-placeholders';

const LicenseSkeletonWrapper = styled.div`
  width: 100%;
  height: 100%;
`;

const LicenseViolationSkeletonWrapper = styled.div`
  width: 50%;
  height: 100%;
`;

function LicenseBlock() {
  return (
    <>
      <SolidSkeletonSection height={20} margin="0px 0px 10px 0px" />
      <Placeholder.Paragraph rows={2} />
      <SolidSkeletonSection
        height={25}
        width={134}
        margin="20px 0px 60px 0px"
      />
    </>
  );
}

function LicenseDetails() {
  return (
    <LicenseSkeletonWrapper>
      <SkeletonTitle margin="0px 0px 42px 0px" />
      <LicenseBlock />
      <LicenseBlock />
      <LicenseBlock />
    </LicenseSkeletonWrapper>
  );
}

function ViolationDetails() {
  return (
    <LicenseViolationSkeletonWrapper>
      <SkeletonBlock height="426" />
    </LicenseViolationSkeletonWrapper>
  );
}

export function LicenseSkeleton() {
  return (
    <LicenseSkeletonWrapper aria-label="Loading skeleton">
      <pd.DetailsWrapper>
        <LicenseDetails />
        <pd.Spacer />
        <ViolationDetails />
      </pd.DetailsWrapper>
    </LicenseSkeletonWrapper>
  );
}
